import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";
import {V1ObjectRevisionIDOCToArray} from "../../../../util/Payload";

/**
 * The objects this record may be related TO, for the picker on "Add related object".
 *
 * ITS OWN COMPONENT RATHER THAN ObjectRevision, for two reasons that both bite:
 *
 *   ObjectRevision keeps its classification in a MODULE-LEVEL variable -- one page is open at a
 *   time, so the grid and its separately-built search component stay in step. A picker borrowing
 *   that component inherits whichever classification the page happens to be showing, along with its
 *   IDOC and its sort: the chooser asked for v1.DocumentRevision-001 sorted by DocumentID and the
 *   service answered 500.
 *
 *   And it would be WRONG even if it worked. An edge may legitimately span classifications -- a
 *   Contract to a Supplier -- so a picker restricted to whatever the current page is would quietly
 *   refuse the relationships most worth recording.
 *
 * CURRENT REVISIONS ONLY. Otherwise the same document appears once per revision, indistinguishable.
 */
const URL = "t1/v1/object_revisions";
const IDOC = "v1.ObjectRevision-001";

class RelatableObjectEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        const members = [{"Type": "Attribute", "Name": "IsCurrent", "Value": true, "Operator": "EQUAL"}];

        // Whatever the chooser's search box is asking for, on top of the current-revision floor.
        const typed = this.prepareQueryPayload();
        if (typed && typed.size > 0) {
            for (const [key, value] of typed) {
                if (key.includes("_query") || key === "IsCurrent") continue;
                const operator = typed.get(key + "_query") ?? "EQUAL";
                members.push({"Type": "Attribute", "Name": key, "Value": value, "Operator": operator});
            }
        }

        const QBE = {
            "PlatformMessage": {
                "-idoc": IDOC,
                "-id": uuidv4(),
                "ObjectRevision": {
                    "_attributes": {
                        "limit": pageSize,
                        "sort": this.getFormattedSortSpecification() || "Name:ASC",
                        "offset": (page - 1) * pageSize,
                    },
                    "QueryGroups": {
                        "QueryGroup": [{
                            "Name": "primary", "Operator": "AND", "Type": "QueryGroup",
                            "Membership": {"Member": members},
                        }],
                    },
                },
            },
        };

        AxiosFoundationAPI({
            method: "GET",
            url: URL,
            json: true,
            params: {"QBE": btoa(JSON.stringify(QBE))},
            headers: {
                "visibility-mode": this.getVisibilityMode(),
                "visibility-value": this.getVisibilityValue(),
                "idoc-response": IDOC,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ObjectRevisionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default RelatableObjectEnterpriseComponent;
